module.exports = __webpack_public_path__ + "img/tournaments.f8f08bbf.svg";